import {
	FormControl,
	InputLabel,
	Link,
	makeStyles,
	MenuItem,
	Select,
} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
	formControl: {
		minWidth: 200,
	},
}));

const AssetReferences = () => {
	const classes = useStyles();
	const referenceItems = [
		{ name: "Truck Blue Book", link: "http://www.truckbluebook.com" },
		{ name: "Truck Paper", link: "http://www.truckpaper.com" },
		{ name: "Machinery Trader", link: "http://www.machinerytrader.com" },
		{ name: "Equipment Watch", link: "http://www.equipmentwatch.com" },
		{ name: "Hitachi", link: "https://l6.hitachifinance.com/app/login.aspx" },
		{ name: "Ryder", link: "http://www.usedtrucks.ryder.com/start/default.aspx" },
		{ name: "Nada", link: "http://www.nada.com" },
		{
			name: "Commercial Truck Trader",
			link: "http://www.commercialtrucktrader.com",
		},
		{
			name: "Auction - Taylor & Martin",
			link: "http://www.taylorandmartin.com/TVG/Default.aspx?ReturnUrl=%2fTVG%2fTVGUser%2fValueGuide.aspx",
		},
		{ name: "Auction - Manheim", link: "https://www.manheim.com/locations/?WT.svl=m_hdr_mnav_locations_us" },
		{ name: "Auction - Ritchie Bros.", link: "https://www.rbauction.com/" },
	];

	return (
		<FormControl className={classes.formControl}>
			<InputLabel id="referencesLabel">References</InputLabel>
			<Select
				placeholder="References"
				className={classes.whiteBackground}
				labelId="referencesLabel"
				id="referenceSelect">
				{referenceItems.map((item) => (
					<MenuItem key={item.name}>
						<Link href={item.link} target="_blank" rel="noreferrer">
							{item.name}
						</Link>
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
export default AssetReferences;
